import { render, staticRenderFns } from "./DrugInventoryItems.vue?vue&type=template&id=11302014&"
import script from "./DrugInventoryItems.vue?vue&type=script&lang=js&"
export * from "./DrugInventoryItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports